/**
 * API Configuration
 * Merkezi API URL yönetimi
 *
 * Production (Vercel): Cloud Run URL
 * Development (localhost): Local backend URL
 */

// Cloud Run backend URL (Production)
const CLOUD_RUN_URL =
  'https://dietitian-backend-843099099815.europe-west3.run.app/api';

// Local development URL
const LOCAL_URL = 'http://localhost:5050/api';

/**
 * Environment'a göre otomatik URL seçimi:
 * - localhost'ta çalışıyorsa: localhost:5050 (local backend)
 * - Vercel'de çalışıyorsa: Cloud Run URL
 */
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

export const API_BASE_URL = isLocalhost ? LOCAL_URL : CLOUD_RUN_URL;

// Debug için konsola yazdır
console.log('🌐 API Configuration:', {
  hostname: window.location.hostname,
  isLocalhost,
  API_BASE_URL,
  environment: isLocalhost
    ? 'Development (Local Backend)'
    : 'Production (Cloud Run)',
});

export default API_BASE_URL;

// API endpoint'leri
export const API_ENDPOINTS = {
  clients: `${API_BASE_URL}/clients`,
  dietitians: `${API_BASE_URL}/dietitians`,
  appointments: `${API_BASE_URL}/appointments`,
  dietPrograms: `${API_BASE_URL}/dietprograms`,
  foods: `${API_BASE_URL}/foods`,
  meals: `${API_BASE_URL}/meals`,
  messages: `${API_BASE_URL}/messages`,
  weightMeasurements: `${API_BASE_URL}/weightmeasurements`,
  email: `${API_BASE_URL}/email`,
  auth: `${API_BASE_URL}/auth`,
};
